/*COMMON*/
export const LOGIN_URL = `${import.meta.env.VITE_APP_LOGIN_URL}`;

/*API*/
export const CMS_PORT = `${import.meta.env.VITE_APP_CMS_URL}`;

/*SERVICE API*/
export const SERVICE_PORT = `${import.meta.env.VITE_APP_CMS_SERVICE_URL}`;

/*CMS API*/
export const QA_PORT = `${import.meta.env.VITE_APP_CMS_QA_URL}`;
